import { render, staticRenderFns } from "./SocialShare.vue.html?vue&type=template&id=40ad114a&scoped=true&"
import script from "./SocialShare.component.js?vue&type=script&lang=vueJs&"
export * from "./SocialShare.component.js?vue&type=script&lang=vueJs&"
import style0 from "./SocialShare.scoped.scss?vue&type=style&index=0&id=40ad114a&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ad114a",
  null
  
)

export default component.exports